(function() {
  'use strict';
  // Network side of the consent gate (docs/consent-gate.md). It drops requests to known tracker hosts, and holds
  // Shopify's web-pixel frames, only while a visitor who must opt in (California, EU) has not. Everyone else is
  // never blocked: until the region is known nothing is held back (consent-gate-eu-us.js turns blocking on with
  // _irBlockTracking once it knows). Turning blocking off never puts the browser's own fetch/XHR/beacon/src/cookie
  // back: other code wraps them after this file runs (Shopify's add-to-cart listener, Replo, OneClickUpsell), and
  // restoring the originals threw those wrappers away (2026-10-23: first-page add-to-cart reached no pixel).
  if (window._irConsentGateInstalled) return;
  window._irConsentGateInstalled = true;
  function noop() {}
  window._irBlockTracking = noop;
  window._irUnblockPixels = noop;
  window._irUnblockTracking = noop;

  var defined = false;
  try { defined = typeof localStorage !== 'undefined' && !!localStorage; } catch (e) {}
  var STORAGE_KEY = 'ir_consent';
  var MAX_AGE_MS = 180 * 24 * 3600 * 1000;
  // Same list as shouldRequireConsent in consent-gate-eu-us.js.
  var CONSENT_REGIONS = [
    'USCA', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT',
    'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
  ];

  // The saved choice ({ a, m }), or null when there is none or it has expired.
  function readSaved() {
    if (!defined) return null;
    try {
      var d = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!d || (d.ts && Date.now() - d.ts > MAX_AGE_MS)) return null;
      return d;
    } catch (e) { return null; }
  }

  if (window.irConsentBypass) return;
  var saved = readSaved();
  if (saved && (saved.a || saved.m)) return;

  // Block from the start only when we already know: an explicit decline, or a cached region that needs consent.
  var startBlocked = !!saved || CONSENT_REGIONS.indexOf(window.irConsentCachedRegion || '') !== -1;
  var _blocking = false; // web-pixel frames held
  var _networkBlocking = false; // tracker requests dropped
  var _blockedFrames = [];
  var WEB_PIXEL_RE = /web-pixel|web-pixels-manager/i;

  var _pixelObserver = null;
  function holdAddedFrames(mutations) {
    if (!_blocking) return;
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeName === 'IFRAME') {
          var src = node.getAttribute('src') || '';
          if (WEB_PIXEL_RE.test(src)) {
            node.dataset.irBlockedSrc = src;
            node.removeAttribute('src');
            _blockedFrames.push(node);
          }
        }
      }
    }
  }

  window._irBlockTracking = function() {
    _networkBlocking = true;
    if (_blocking) return;
    _blocking = true;
    try {
      if (!_pixelObserver) _pixelObserver = new MutationObserver(holdAddedFrames);
      _pixelObserver.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  };

  // Safe to call any number of times. Leaves every wrapper in place as a pass-through.
  window._irUnblockTracking = function() {
    _networkBlocking = false;
  };

  window._irUnblockPixels = function() {
    _blocking = false;
    if (_pixelObserver) _pixelObserver.disconnect();
    var frames = _blockedFrames;
    _blockedFrames = [];
    for (var i = 0; i < frames.length; i++) {
      var origSrc = frames[i].dataset.irBlockedSrc;
      if (origSrc) {
        delete frames[i].dataset.irBlockedSrc;
        frames[i].src = origSrc;
      }
    }
  };

  // Tracker hosts (the host or any subdomain of it), plus tracking paths on shared Google/Facebook hosts. Only
  // these are ever blocked: never our own domain, Shopify, or an app's API.
  var BLOCKED_HOSTS = [
    'clarity.ms', 'c.bing.com', 'bat.bing.com', 'google-analytics.com', 'analytics.google.com', 'googleadservices.com',
    'doubleclick.net', 'pagead2.googlesyndication.com', 'connect.facebook.net', 'kendall.ai'
  ];
  var BLOCKED_PATHS = [
    { host: 'google.com', path: /^\/(ccm|pagead|g\/collect|j\/collect)(\/|$)/ },
    { host: 'googlesyndication.com', path: /ccm/ },
    { host: 'facebook.com', path: /^\/tr(\/|$)/ }
  ];

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    if (input && typeof input.toString === 'function') return input.toString();
    return '';
  }
  function onHost(host, base) {
    return host === base || host.slice(-(base.length + 1)) === '.' + base;
  }
  function isTrackingUrl(input) {
    var u;
    try {
      u = new URL(urlOf(input), location.href);
    } catch (e) { return false; }
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return false;
    var host = u.hostname.toLowerCase();
    for (var i = 0; i < BLOCKED_HOSTS.length; i++) {
      if (onHost(host, BLOCKED_HOSTS[i])) return true;
    }
    for (var j = 0; j < BLOCKED_PATHS.length; j++) {
      if (onHost(host, BLOCKED_PATHS[j].host) && BLOCKED_PATHS[j].path.test(u.pathname)) return true;
    }
    return false;
  }
  function blocked(input) {
    return _networkBlocking && isTrackingUrl(input);
  }

  // Each install is separate: one that fails leaves the others, and the functions above, in place.
  try {
    var _origBeacon = navigator.sendBeacon;
    if (typeof _origBeacon === 'function') {
      navigator.sendBeacon = function(url) {
        if (blocked(url)) return true;
        return _origBeacon.apply(navigator, arguments);
      };
    }
  } catch (e) {}

  try {
    var _origFetch = window.fetch;
    if (typeof _origFetch === 'function') {
      window.fetch = function(input) {
        if (blocked(input)) return Promise.resolve(new Response('', { status: 200 }));
        return _origFetch.apply(window, arguments);
      };
    }
  } catch (e) {}

  // XHR: a blocked request is opened to an empty data: URL instead, so the browser runs the whole request
  // (headers, events, sync or async) and answers an empty 200 without any network call. Nothing waits forever.
  try {
    var _origXhrOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      if (blocked(url)) {
        var args = Array.prototype.slice.call(arguments);
        args[1] = 'data:,';
        return _origXhrOpen.apply(this, args);
      }
      return _origXhrOpen.apply(this, arguments);
    };
  } catch (e) {}

  try {
    var _iframeSrcDesc = Object.getOwnPropertyDescriptor(HTMLIFrameElement.prototype, 'src');
    if (_iframeSrcDesc && _iframeSrcDesc.set) {
      Object.defineProperty(HTMLIFrameElement.prototype, 'src', {
        get: function() { return _iframeSrcDesc.get.call(this); },
        set: function(val) {
          if (_blocking && WEB_PIXEL_RE.test(val)) {
            this.dataset.irBlockedSrc = val;
            _blockedFrames.push(this);
            return;
          }
          _iframeSrcDesc.set.call(this, val);
        },
        configurable: true
      });
    }
  } catch (e) {}

  try {
    var _imgSrcDesc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
    if (_imgSrcDesc && _imgSrcDesc.set) {
      Object.defineProperty(HTMLImageElement.prototype, 'src', {
        get: function() { return _imgSrcDesc.get.call(this); },
        set: function(val) {
          if (blocked(val)) return;
          _imgSrcDesc.set.call(this, val);
        },
        configurable: true
      });
    }
  } catch (e) {}

  try {
    var _scriptSrcDesc = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src');
    if (_scriptSrcDesc && _scriptSrcDesc.set) {
      Object.defineProperty(HTMLScriptElement.prototype, 'src', {
        get: function() { return _scriptSrcDesc.get.call(this); },
        set: function(val) {
          if (blocked(val)) return;
          _scriptSrcDesc.set.call(this, val);
        },
        configurable: true
      });
    }
  } catch (e) {}

  var COOKIE_BLOCKED_RE = /^\s*(_ga|_gid|_gat|_gac_|_gcl|_gads|_gpi|_clck|_clsk|CLID|ANONCHK|MR|MUID|SM|_fbp|_fbc|cto_|__hs|hubspotutk|_uetmsclkid|_ttp|_tt_)\b/;
  var _cookieDesc = null;
  try {
    _cookieDesc = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') || Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
    if (_cookieDesc && _cookieDesc.set) {
      Object.defineProperty(document, 'cookie', {
        get: function() { return _cookieDesc.get.call(document); },
        set: function(val) {
          if (_networkBlocking && COOKIE_BLOCKED_RE.test(val)) return;
          _cookieDesc.set.call(document, val);
        },
        configurable: true
      });
    }
  } catch (e) {}

  window._irGetCookieDesc = function() { return _cookieDesc; };

  if (startBlocked) window._irBlockTracking();

  // If the consent manager never ran (its file failed to load), allow tracking for this page rather than leaving
  // it blocked. A saved decline stays blocked.
  document.addEventListener('DOMContentLoaded', function() {
    if (window._irConsentManagerStarted || saved) return;
    window._irUnblockTracking();
    window._irUnblockPixels();
  });
})();
